import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=617559a9&scoped=true"
import script from "./CCard.vue?vue&type=script&lang=js"
export * from "./CCard.vue?vue&type=script&lang=js"
import style0 from "./CCard.vue?vue&type=style&index=0&id=617559a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617559a9",
  null
  
)

export default component.exports